import * as React from 'react';
import {withJsonFormsControlProps} from '@jsonforms/react';
import Signature from "./Signature";

interface SignatureControlProps {
    path: string;
    handleChange(path: string, file: string): void;
    uischema: any;
    schema: any;
    rootSchema: any;
    appValidated?: boolean;
}

const SignatureControl = ({ uischema, schema, handleChange, path, rootSchema, appValidated }: SignatureControlProps) => {

    return (
        <Signature
            path={path}
            rootSchema={rootSchema}
            schema={schema}
            uiSchema={uischema}
            onEnd={(file: string) => handleChange(path, file)}
            appValidated={appValidated}
        />
    );
};

export default withJsonFormsControlProps(SignatureControl);
